
const DESKTOPHD = "1440px";
const TABLET = "1024px";
const MOBILE = "768px";


const usefull = {

    isMobile: () => window.matchMedia("(max-width:768px)").matches,

    // isTablet: function(){ return window.matchMedia("(max-width:1024px)").matches},
    isTablet: () => window.matchMedia("(max-width:1024px)").matches ,

    isDesktop: () => window.matchMedia("(min-width:1440px)").matches,

}

export default usefull